export default __webpack_public_path__ + "static/media/rockAndRollMcDonalds.bfa12f32.wav";